import { render, staticRenderFns } from "./setapikey.vue?vue&type=template&id=52be45b8&"
import script from "./setapikey.vue?vue&type=script&lang=ts&"
export * from "./setapikey.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "setapikey.vue"
export default component.exports